import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

function ServiceProviderSMSDisclosure({ showDisclosure, setShowDisclosure }) {
  return (
    <Box>
      <button
        type="button"
        onClick={() => setShowDisclosure(true)}
        style={{
          background: 'none',
          border: 'none',
          color: '#1976d2',
          textDecoration: 'underline',
          cursor: 'pointer',
          padding: 0,
          font: 'inherit',
        }}>
        Disclosure
      </button>
      <Dialog open={showDisclosure} onClose={() => setShowDisclosure(false)}>
        <DialogTitle>SMS Opt-In Disclosure</DialogTitle>
        <DialogContent>
          <Typography>
            By selecting SMS Opt-In, you agree to receive text message
            notifications about your jobs and updates from Service Xcelerator.
          </Typography>
          <ul style={{ margin: 0, padding: '10px 0 0 17px' }}>
            <li>
              Your phone number will not be shared with the customer or sold or
              shared with third parties for marketing or promotional purposes.
            </li>
            <li>
              Msg & Data rates may apply. Msg frequency varies based on service
              activity. Reply HELP for help.
            </li>
            <li>
              You can opt out anytime by changing this setting or replying STOP
              to any SMS message.
            </li>
          </ul>
          <Stack
            sx={{ justifySelf: 'center', mt: 2 }}
            direction="row"
            spacing={2}>
            <a target="_blank" href="/legal/terms">
              Terms
            </a>
            <a target="_blank" href="/legal/privacy">
              Privacy
            </a>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => setShowDisclosure(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ServiceProviderSMSDisclosure;
